import * as React from "react";
import { connect } from "react-redux";
import uhaulStore from "../CustomRedux/UhaulStore"
import { updateTaskContexts } from "./Actions/CannedResponsesActions";
import { CMGT } from "./CMGT";
import {GetCustomerData} from "../RefreshStats";
import { CMGTCustomerInfo } from "./CMGTCustomerInfo";
import { CannedMessages } from "./CannedMessages";

export class CRM extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            attributes: null,
            newProps: { ...this.props }
        };

    }

    state = this.getCurrentStateFromStore()

    getCurrentStateFromStore() {
        return {
            config: uhaulStore.getState().FlexReducer.config,
            taskContexts: uhaulStore.getState().UhaulReducer.currentTaskContext,
            customerDataList: uhaulStore.getState().UhaulReducer.customerDataList
        }
    }

    updateStateFromStore = () => {
        const currentState = this.getCurrentStateFromStore();

        if (this.state !== currentState) {
            this.setState(currentState);
        }
    }

    componentDidUpdate(){
        GetCustomerData(this.props);
    }

    render() {
        var taskContexts = uhaulStore.getState().UhaulReducer.currentTaskContext
        const customerServiceQueues = [
            "UBOX",
            "GENERAL-QUESTIONS",
            "SELF-STORAGE",
            "RENTAL-EQUIPMENT",
            "RETAIL-SALES",
            "TEST-QUEUE",
            "E-MOBILE-PICK-UP",
            "OUTSTANDING-BALANCE",
            "ROADSIDE"
        ];

        if (this.props?.task != null) {

            if (taskContexts?._task == null || (this.props.task._task.sid !== uhaulStore.getState().UhaulReducer.currentTaskContext._task.sid)) {
                uhaulStore.dispatch(updateTaskContexts(this.props.task));
                taskContexts = this.props.task
            }

            if ((taskContexts._task.status !== "pending" && taskContexts._task.status !== "completed")) {
                let taskQueueName = null;
                const allQueues = uhaulStore.getState().UhaulReducer.allQueues;
                if (taskContexts._task && taskContexts._task.queueName){
                    taskQueueName = taskContexts._task.queueName;
                }
                const queueMatch = allQueues.find(queueItem => 
                    queueItem.Name.toLowerCase().trim() === 
                    (taskQueueName ? taskQueueName.toLowerCase().trim() : '')
                  );

                /*Shows only for Customer Service queues */
                if (customerServiceQueues.find(x => x === (queueMatch && queueMatch.Type ? queueMatch.Type.toUpperCase() : ''))) {
                    return (<div className="CRM_Panel">
                        <div className="leftPanel">
                            <section>
                                <div id="customerInfoPanel" className="subUp">
                                    <CMGTCustomerInfo props={this.props}></CMGTCustomerInfo>
                                </div>
                            </section>
                            <section>
                                <div id="cannedMessagesPanel" className="subDwn">
                                    <CannedMessages props={this.props}></CannedMessages>
                                </div>
                            </section>
                        </div>
                        <div className="rightPanel">
                            <section>
                                <div id="cmgtPanel" className="subUp">
                                    <CMGT props={this.props}></CMGT>
                                </div>
                            </section>
                        </div>
                    </div>);
                }
                else {
                    return (<div id="cannedMessagesPanel" className="subDwn">
                            <CannedMessages props={this.props}></CannedMessages>
                        </div>);
                }
            }
            else {
                return (<div className="loadingCRMData" />);
            }
        }
        else {
            return (<div className="loadingCRMData" />);
        }
    }
}

const mapStateToProps = (store) => {
    return {
        config: store.FlexReducer.config,
        taskContexts: store.UhaulReducer.currentTaskContext,
        customerDataList: store.UhaulReducer.customerDataList
    };
};

export default connect(
    mapStateToProps
)(CRM);
